export const renderDividendPeriod = [
  {
    value: "None",
    label: "None",
  },
  {
    value: "Daily",
    label: "Daily",
  },
  {
    value: "Monthly",
    label: "Monthly",
  },
  {
    value: "Quarterly",
    label: "Quarterly",
  },
  {
    value: "Half Yearly",
    label: "Half Yearly",
  },
  {
    value: "Yearly",
    label: "Yearly",
  },
];
export const arrFundManagement = [
  {
    value: "main_fund",
    label: "Main Fund",
  },
  {
    value: "sub_fund",
    label: "Sub Fund",
  },
  {
    value: "plan",
    label: "Plan",
  },
];

export const Money_market = [
  {
    value: "PIB",
    label: "Pakistan Investment Bonds",
  },
  {
    value: "TBILL",
    // label: "Treasuary bill",
    label: "Treasury bill",
  },
];
export const Debt_market = [
  {
    value: "SUKUK",
    label: "Sukuk Certificates",
  },
  {
    value: "TFC",
    label: "Term Finance Certificates",
  },
  {
    value: "CP",
    label: "Commercial Papers",
  },
];
export const Term_market = [
  {
    value: "TDR",
    label: "Term Deposit Receipts",
  },
  {
    value: "CDR",
    label: "Certificate Of Investment",
  },
  {
    value: "LOP",
    label: "Letter of Placement",
  },
];

export const renderMarketArr = [
  {
    value: "REG",
    label: "Regular",
  },
  {
    value: "ODL",
    label: "Odd Lot",
  },
  {
    value: "FUT",
    label: "Future",
  },
  {
    value: "BNB",
    label: "Bills and Bonds",
  },
  {
    value: "IPO",
    label: "Initial Public Offering",
  },
  {
    value: "BKB",
    label: "Book Building",
  },
  {
    value: "CSF",
    label: "Cash Settled Futures",
  },
  {
    value: "DSF",
    label: "Direct Settled Futures",
  },
  {
    value: "SIF",
    label: "Stock Index Futures",
  },
  {
    value: "NDM",
    label: "Negotiable Deal Market",
  },
  {
    value: "FRO",
    label: "Future Rollover Contract",
  },
  {
    value: "MTS",
    label: "Margin Trading System",
  },
  {
    value: "SQR",
    label: "Square Up",
  },
];

export const typeArr = [
  { label: "Term Deposit Receipts", value: "TDR" },
  { label: "Certificate Of Investment", value: "CDR" },
  { label: "Letter of Placement", value: "LOP" },
];

export const riskFactorOpt = [
  {
    label: "Low",
    value: "Low",
  },
  {
    label: "Medium",
    value: "Medium",
  },
  {
    label: "High",
    value: "High",
  },
];

export const trusteeArr = [
  {
    label: "DCCL",
    value: "DCCL",
  },
  {
    label: "CDC",
    value: "CDC",
  },
];
